/// <reference path="../pocmemberform.js" />
import React, { useEffect, useState } from 'react';
import { Alert, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import '../../../../styles/Forms.css';
import { AccessCheckBox } from '../AccessCheckBox';
import { ServicesAndSolutionsAlert } from '../../RegDashboard/ServicesAndSolutionsAlert';

export function ServicesSection(props) {
    const [loading, setLoading] = useState(true);
    const [provider, setProvider] = useState(false);
    const [chrAllowed, setChrAllowed] = useState(false);
    const [dsmAllowed, setDsmAllowed] = useState(false);
    const [referralsAllowed, setReferralsAllowed] = useState(false);
    const [notifyAllowed, setNotifyAllowed] = useState(false);
    const [account, setAccount] = useState(null);
    const [member, setMember] = useState(null);
    const [user, setUser] = useState(props.user);

    useEffect(() => {
        if (props.account) {
            setAccount(props.account);
        }
        if (props.member) {
            setMember(props.member);
        }
        setProvider(props.provider);
    }, [props])

    useEffect(() => {
        if (account && member) {
            setLoading(false);
            setChrAllowed(checkChrAllowed() || member.chr);
            setDsmAllowed((account.dsm || (account.registrationType && account.registrationType.includes("DSM"))) || member.dsm);
            setReferralsAllowed((account.referrals || (account.registrationType && account.registrationType.includes("Referrals"))) || member.referrals);
            setNotifyAllowed(checkNotifyAllowed() || member.notify);
        }
    }, [account, member, provider])

    const checkChrAllowed = () => {
        var result;
        if (account.chr || (account.registrationType && account.registrationType.includes("CHR"))) {
            if (!account.chrIsLimited) {
                result = true;
            }
            else if (provider && remainingChrProviders() > 0) {
                result = true;
            }
            else if (!provider && remainingChrStaff() > 0) {
                result = true;
            }
            else { result = false; }
        }
        else { result = false }
        return result;
    }

    const checkNotifyAllowed = () => {
        var result;
        if (account.notify || (account.registrationType && account.registrationType.includes("Notify"))) {
            if (!account.notifyIsLimited) {
                result = true;
            }
            else if (provider && remainingNotifyProviders() > 0) {
                result = true;
            }
            else if (!provider && remainingNotifyStaff() > 0) {
                result = true;
            }
            else { result = false; }
        }
        else { result = false }
        return result;
    }


    const remainingChrProviders = () => {
        return (parseInt(account.chrProviderLimit) - account.chrProviderCount);
    }

    const remainingChrStaff = () => {
        return (parseInt(account.chrStaffLimit) - account.chrStaffCount);
    }

    const remainingNotifyProviders = () => {
        return (parseInt(account.notifyProviderLimit) - account.notifyProviderCount);
    }

    const remainingNotifyStaff = () => {
        return (parseInt(account.notifyStaffLimit) - account.notifyStaffCount);
    }

    return (
        <>
            {!loading &&
                <>
                <Row style={{ padding: "15px" }}>
                    <Col></Col>                    <OverlayTrigger
                        placement="bottom"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip id="solutions-tip">Your Organization may have limited access to these based on subscription</Tooltip>}
                    >
                        <Col className="d-flex justify-content-center" style={{ padding: "4px" }} sm={8}>
                            <Alert
                                variant="primary"
                                style={{
                                    paddingTop: 4,
                                    marginBottom: 10,
                                    paddingBottom: 20,
                                    borderRadius: '10px'
                                }}
                            > 

                            <Alert.Heading>Services, Solutions and Access</Alert.Heading>
                            {chrAllowed &&
                                <AccessCheckBox
                                label="Community Health Record"
                                id="chr-access-check"
                                checked={props.chr}
                                set={(value) => { props.setChr(value) }}
                                disabled={!chrAllowed}
                            />}
                            {/*{chrAllowed &&*/}
                            {/*    <AccessCheckBox*/}
                            {/*    label="Referrals"*/}
                            {/*    id="referrals-check"*/}
                            {/*    checked={props.referrals && props.chr}*/}
                            {/*    set={(value) => { props.setReferrals(value) }}*/}
                            {/*    disabled={!referralsAllowed || !props.chr}*/}
                            {/*/>}*/}
                            {chrAllowed &&
                                <AccessCheckBox
                                label="Direct Secure Messaging"
                                id="dsm-check"
                                checked={props.dsm && props.chr}
                                set={(value) => { props.setDsm(value) }}
                                disabled={!dsmAllowed || !props.chr}
                            />}
                            {notifyAllowed &&
                                <AccessCheckBox
                                label="Notify"
                                id="notify-check"
                                checked={props.notify}
                                set={(value) => { props.setNotify(value) }}
                                disabled={!notifyAllowed}
                            />}
                    </Alert>
                        </Col>
                        </OverlayTrigger>
                    <Col></Col>
                </Row>
                <ServicesAndSolutionsAlert account={account} user={user} member={member} provider={provider} />
                </>
            }
        </>
    );
}